import { getStudentResultByMeasureYearGradePeriod } from '../../../../utils/shared/filterUtils';
import { NA, PERIOD } from '../../../../constants/shared/CommonConstants';
import { getGradeTitle, GRADE, THREE_GRADES } from '../../../../constants/shared/GradesConstants';
import { isMeasureEnabledForSpecificMapper } from '../../../../utils/shared/tableUtils';

export const getColumnTitles = (currentSchoolYear, listOfGrades) => {
    let listOfColumnTitles = listOfGrades.map(
        (grade, index, array) =>
            `${getGradeTitle(grade)} (${currentSchoolYear - array.length + index} - ${
                currentSchoolYear - array.length + index + 1
            })`,
    );
    const lastIndex = listOfColumnTitles.length;

    listOfColumnTitles.length = THREE_GRADES;
    listOfColumnTitles = listOfColumnTitles.fill('', lastIndex, THREE_GRADES);

    return listOfColumnTitles;
};

export const getColumns = (
    listOfGrades,
    interps,
    statuses,
    measure,
    currentSchoolYear,
    DefaultGradeToMeasureMapper,
    getGoalSection,
    toyPeriods,
    grade,
    summerPeriodLabel,
    isLouisiana = false,
) => {
    let listOfGradeTitles = listOfGrades.map((gradeYear, index, array) => {
        const filteredToyPeriods = toyPeriods.filter(period => {
            const isThirdGradeLA =
                isLouisiana && grade === GRADE.THIRD_GRADE && gradeYear === grade;
            const isMatchingGrade = gradeYear === grade;
            const isNotSummer = period !== PERIOD.SUMMER;

            return isLouisiana ? isThirdGradeLA || isNotSummer : isMatchingGrade || isNotSummer;
        });
        return {
            gradeYear,
            isSummerPeriodPresent: filteredToyPeriods.includes(PERIOD.SUMMER),
            cells: filteredToyPeriods.map(period => {
                const goal = getGoalSection(
                    isMeasureEnabledForSpecificMapper(
                        measure,
                        gradeYear,
                        period,
                        DefaultGradeToMeasureMapper,
                    ),
                    interps,
                    measure,
                    gradeYear,
                    period,
                    '',
                );
                return {
                    period: period === PERIOD.SUMMER ? summerPeriodLabel : period,
                    // Sould befixed after release 8/5 2022
                    goal: goal === 'null' ? NA : goal,
                    status: getStudentResultByMeasureYearGradePeriod(
                        statuses,
                        measure,
                        currentSchoolYear - array.length + index + 1,
                        gradeYear,
                        period,
                    ),
                };
            }),
        };
    });
    const lastIndex = listOfGradeTitles.length;

    listOfGradeTitles.length = THREE_GRADES;
    listOfGradeTitles = listOfGradeTitles.fill({ cells: [] }, lastIndex, THREE_GRADES);

    return listOfGradeTitles;
};
